export default __webpack_public_path__ + "static/media/krzyzowka_4_rozw.bb54cdb2.jpg";